import ConnectionsPage from "./components/Connections/ConnectionsPage";
import useSuperAdmin from "../../security/useSuperAdmin";

const Callbacks = () => {
  const isSuperAdmin = useSuperAdmin();
  if (!isSuperAdmin) return <ConnectionsPage />;
  return <ConnectionsPage />;
};

export default Callbacks;
